type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  readPhaseProcess: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}
export type ClientData = {
  cpf: string
  created_at: string
  deleted_at?: string
  email: string
  id: number
  name: string
  status: string
  type: string
  values?: string
  updated_at: string
}

export type PhaseProcessData = {
  id: number
  cpf: string
  name: string
  payment_form: string
  status: string
  values: number
  created_at: string
  updated_at: string
  deleted_at?: string
}

const nameEntity = 'PhaseProcess'
const nameSource = 'commercial/phasesProcess'
const namePageTitle = 'Fases do processo'
const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Fases do processo',
  to: '/commercial/phasesProcess',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/commercial/phasesProcess/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/commercial/phasesProcess/',
    icon: 'fa fa-list'
  },
  readPhaseProcess: {
    name: 'Contratos',
    to: '/commercial/phasesProcess/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/commercial/phasesProcess/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
